// import React, { useEffect, useMemo, useState } from "react";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import { Panel } from "../../components/ui/dashboard";

// type EntityRole = "user" | "consignor" | "receiver" | "driver" | "consignee";
// type Mode = "add" | "list" | "edit";

// interface Props {
//   role: EntityRole;
//   mode: Mode;
//   title: string;
// }

// // ─────────────────────────────────────────────────────────────
// // Hidden defaults — built as a function so email timestamp is
// // always fresh at call time, not frozen at module load.
// // These are NEVER stored in form state; injected only in payload.
// // ─────────────────────────────────────────────────────────────
// const getHiddenDefaults = (): Record<string, string> => ({
//   password: "company@135",
//   email: `consignmentTest+${Date.now()}@gmail.com`,
//   bank_name: "Default Bank",
//   bank_account_number: "0000000000",
//   bank_ifsc: "DEFB0000000",
//   account_holder_name: "Account Holder",
//   // gst_number: "GST000000000000",
//   pan_number: "PANNOTPROV",
//   aadhaar_number: "000000000000",
//   license_number: "LIC000000000",
//   govt_id_type: "Other",
//   govt_id_number: "GOVTID000000",
// });

// // Visible fields per role — hidden fields must NOT appear here
// const fieldConfigByRole: Record<EntityRole, string[]> = {
//   user: ["name", "email", "number", "address", "city", "state", "pincode"],
//   consignor: ["name", "number", "address", "gst_number"],
//   receiver: ["name", "email", "number", "address", "city", "state", "pincode"],
//   driver: ["name", "email", "number", "address"],
//   consignee: ["name", "number", "address", "gst_number"],
// };

// // Required fields per role — only visible ones
// const requiredFieldsByRole: Record<EntityRole, (mode: Mode) => string[]> = {
//   user: () => [],
//   consignor: () => [],
//   receiver: () => [],
//   driver: () => [],
//   consignee:()=>[],
// };

// const labels: Record<string, string> = {
//   name: "Full Name",
//   email: "Email",
//   number: "Mobile Number",
//   address: "Address",
//   city: "City",
//   state: "State",
//   pincode: "Pincode",
// };

// // initialForm only contains visible field keys (no hidden fields ever)
// const ALL_VISIBLE_FIELDS = Array.from(
//   new Set(Object.values(fieldConfigByRole).flat())
// );
// const initialForm = ALL_VISIBLE_FIELDS.reduce<Record<string, string>>((acc, key) => {
//   acc[key] = "";
//   return acc;
// }, {});

// const AdminEntityPage: React.FC<Props> = ({ role, mode, title }) => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [rows, setRows] = useState<any[]>([]);
//   const [form, setForm] = useState<Record<string, string>>(initialForm);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState<string | null>(null);
//   const [errors, setErrors] = useState<Record<string, string>>({});
//   const [deleteId, setDeleteId] = useState<string | null>(null);
//   const [deleteLoading, setDeleteLoading] = useState(false);
//   const [deleteError, setDeleteError] = useState<string | null>(null);
//   const apiUrl = process.env.REACT_APP_API_URL;

//   const fields = useMemo(() => fieldConfigByRole[role], [role]);
//   // Required fields function signature now takes mode
//   const requiredFields = useMemo(() => {
//     // Accepts both legacy array and our new function signature for safety, but our own type guards it
//     const req = requiredFieldsByRole[role];
//     if (typeof req === "function") {
//       return req(mode);
//     }
//     return req;
//   }, [role, mode]);

//   // List fetch
//   useEffect(() => {
//     if (!apiUrl || mode !== "list") return;
//     fetch(`${apiUrl}/auth/admin/users?role=${role}`)
//       .then((r) => r.json())
//       .then((d) => setRows(Array.isArray(d) ? d : []))
//       .catch(() => setRows([]));
//   }, [apiUrl, mode, role]);

//   // Edit fetch — only populate visible fields
//   useEffect(() => {
//     if (!apiUrl || mode !== "edit" || !id) return;
//     fetch(`${apiUrl}/auth/user/${id}`)
//       .then((r) => r.json())
//       .then((d) => {
//         setForm((prev) => {
//           const next = { ...prev };
//           ALL_VISIBLE_FIELDS.forEach((key) => {
//             next[key] = d?.[key] ?? "";
//           });
//           return next;
//         });
//       })
//       .catch(() => setMessage("Could not load record"));
//   }, [apiUrl, mode, id]);

//   const validate = () => {
//     const newErrors: Record<string, string> = {};
//     requiredFields.forEach((field) => {
//       if (!form[field]?.trim()) {
//         newErrors[field] = "Required";
//       }
//     });
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const onSave = async () => {
//     if (!apiUrl) return;
//     setMessage(null);
//     if (!validate()) {
//       setMessage("Please fill required fields.");
//       return;
//     }
//     setLoading(true);

//     try {
//       const hiddenDefaults = getHiddenDefaults();

//       // Build payload: hidden defaults first, then visible form values on top.
//       // For any field that is hidden for this role (e.g. email on consignor),
//       // the form value will be "" — we explicitly restore the default after.
//       const payload: Record<string, string> = {
//         ...hiddenDefaults,
//         ...form,
//         role,
//       };

//       // Restore hidden defaults for fields not visible in this role
//       Object.keys(hiddenDefaults).forEach((key) => {
//         if (!fields.includes(key) || !payload[key]?.trim()) {
//           payload[key] = hiddenDefaults[key];
//         }
//       });

//       const endpoint =
//         mode === "edit" && id
//           ? `${apiUrl}/auth/admin/users/${id}`
//           : `${apiUrl}/auth/admin/users`;

//       const res = await fetch(endpoint, {
//         method: mode === "edit" ? "PUT" : "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data?.error || "Save failed");

//       setMessage(mode === "edit" ? "Updated successfully" : "Created successfully");
//       if (mode === "add") setForm(initialForm);
//       if (mode === "edit") navigate(`/admin/${role}s/list`);
//     } catch (e: any) {
//       setMessage(e?.message || "Save failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // New: Delete (for list page, with row id as param)
//   const onDelete = async (rowId: string) => {
//     if (!apiUrl || !rowId) return;
//     setDeleteLoading(true);
//     setDeleteError(null);
//     try {
//       const resp = await fetch(`${apiUrl}/auth/admin/users/${rowId}`, {
//         method: "DELETE",
//         headers: { "Content-Type": "application/json" }
//       });
//       let data: any = {};
//       try {
//         data = await resp.json();
//       } catch {}
//       if (!resp.ok) throw new Error(data?.error || "Delete failed");
//       setDeleteLoading(false);
//       setDeleteError(null);
//       setRows(rows => rows.filter(r => r.id !== rowId));
//       setDeleteId(null);
//     } catch (e: any) {
//       setDeleteLoading(false);
//       setDeleteError(e?.message || "Delete failed");
//     }
//   };

//   // ── LIST VIEW ──────────────────────────────────────────────
//   if (mode === "list") {
//     return (
//       <div className="p-4 md:p-6 ">
//         <Panel
//           title={`${title} - List`}
//           subtitle={`Show all ${role} records with edit option`}
//         >
//           <div className="mb-3">
//             <Link
//               to={`/admin/${role}s/add`}
//               className="px-3 py-2 rounded-lg text-sm bg-slate-900 text-white"
//             >
//               Add {title}
//             </Link>
//           </div>
//           <div className="space-y-2">
//             {rows.map((row) => (
//               <div
//                 key={row.id}
//                 className="rounded-xl border border-slate-100 p-3 flex items-center justify-between"
//               >
//                 <div>
//                   <p className="text-sm font-semibold text-slate-900">{row.name}</p>
//                   <p className="text-xs text-slate-500">
//                 {row.number}
//                   </p>
//                 </div>
//                 <div className="flex items-center gap-2">
//                   <Link
//                     to={`/admin/${role}s/edit/${row.id}`}
//                     className="px-2 py-1 text-xs rounded-md bg-slate-100 text-slate-700"
//                   >
//                     Edit
//                   </Link>
//                   <button
//                     className="px-2 py-1 text-xs rounded-md bg-red-100 text-red-700"
//                     disabled={deleteLoading && deleteId === row.id}
//                     onClick={() => setDeleteId(row.id)}
//                     type="button"
//                   >
//                     {deleteLoading && deleteId === row.id ? "Deleting..." : "Delete"}
//                   </button>
//                   {/* Centered big modal for delete confirmation */}
//                   {deleteId === row.id && (
//                     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
//                       <div className="bg-white rounded-xl shadow-2xl border border-red-200 px-8 py-6 flex flex-col items-center">
//                         <span className="text-lg font-semibold text-red-700 mb-4">Are you sure you want to delete?</span>
//                         <div className="flex gap-3">
//                           <button
//                             onClick={() => onDelete(row.id)}
//                             className="px-5 py-2 rounded text-md bg-red-600 text-white font-semibold"
//                             disabled={deleteLoading}
//                             type="button"
//                           >
//                             {deleteLoading ? "Deleting..." : "Yes, Delete"}
//                           </button>
//                           <button
//                             onClick={() => setDeleteId(null)}
//                             className="px-5 py-2 rounded text-md bg-slate-100 text-slate-700 font-semibold"
//                             disabled={deleteLoading}
//                             type="button"
//                           >
//                             Cancel
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   )}
             
//                 </div>
//               </div>
//             ))}
//           </div>
//           {deleteError && (
//             <div className="mt-3 text-xs text-red-600">{deleteError}</div>
//           )}
//         </Panel>
//       </div>
//     );
//   }

//   // ── ADD / EDIT VIEW ────────────────────────────────────────
//   return (
//     <div className="p-4 md:p-6">
//       <Panel
//         title={`${mode === "edit" ? "Edit" : "Add"} ${title}`}
//         subtitle={`Manage ${role} details`}
//       >
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//           {fields.map((field) => (
//             <div key={field} className="flex flex-col">
//               <input
//                 className={`border rounded-lg px-3 py-2 text-sm ${
//                   errors[field] ? "border-red-500" : ""
//                 }`}
//                 placeholder={
//                   labels[field]
//                     ? `${labels[field]}${requiredFields.includes(field) ? " *" : ""}`
//                     : field
//                 }
//                 value={form[field] ?? ""}
//                 onChange={(e) =>
//                   setForm((prev) => ({ ...prev, [field]: e.target.value }))
//                 }
//                 required={requiredFields.includes(field)}
//                 autoComplete="off"
//               />
//               {errors[field] && (
//                 <span className="text-xs text-red-600 mt-1">{errors[field]}</span>
//               )}
//             </div>
//           ))}
//         </div>

//         {message && <p className="text-xs text-slate-600 mt-3">{message}</p>}

//         <div className="mt-4 flex justify-end gap-2">
//           <Link
//             to={`/admin/${role}s/list`}
//             className="px-3 py-2 rounded-lg text-sm bg-slate-100 text-slate-700"
//           >
//             Back
//           </Link>
//           <button
//             onClick={onSave}
//             disabled={loading}
//             className="px-3 py-2 rounded-lg text-sm bg-indigo-600 text-white disabled:opacity-60"
//           >
//             {loading ? "Saving..." : mode === "edit" ? "Update" : "Create"}
//           </button>
//         </div>
//       </Panel>
//     </div>
//   );
// };

// export default AdminEntityPage;

import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Panel } from "../../components/ui/dashboard";

type EntityRole = "user" | "consignor" | "receiver" | "driver" | "consignee";
type Mode = "add" | "list" | "edit";

interface Props {
  role: EntityRole;
  mode: Mode;
  title: string;
}

// ─────────────────────────────────────────────────────────────
// Hidden defaults — built as a function so email timestamp is
// always fresh at call time, not frozen at module load.
// These are NEVER stored in form state; injected only in payload.
// ─────────────────────────────────────────────────────────────
const getHiddenDefaults = (): Record<string, string> => ({
  password: "company@135",
  email: `consignmentTest+${Date.now()}@gmail.com`,
  bank_name: "Default Bank",
  bank_account_number: "0000000000",
  bank_ifsc: "DEFB0000000",
  account_holder_name: "Account Holder",
  // gst_number: "GST000000000000",
  pan_number: "PANNOTPROV",
  aadhaar_number: "000000000000",
  license_number: "LIC000000000",
  govt_id_type: "Other",
  govt_id_number: "GOVTID000000",
});

// Visible fields per role — hidden fields must NOT appear here
const fieldConfigByRole: Record<EntityRole, string[]> = {
  user: ["name", "email", "number", "address", "city", "state", "pincode"],
  consignor: ["name", "number", "address", "gst_number"],
  receiver: ["name", "email", "number", "address", "city", "state", "pincode"],
  driver: ["name", "email", "number", "address"],
  consignee: ["name", "number", "address", "gst_number"],
};

// Required fields per role — only visible ones
const requiredFieldsByRole: Record<EntityRole, (mode: Mode) => string[]> = {
  user: () => [],
  consignor: () => [],
  receiver: () => [],
  driver: () => [],
  consignee:()=>[],
};

const labels: Record<string, string> = {
  name: "Full Name",
  email: "Email",
  number: "Mobile Number",
  address: "Address",
  city: "City",
  state: "State",
  pincode: "Pincode",
};

// initialForm only contains visible field keys (no hidden fields ever)
const ALL_VISIBLE_FIELDS = Array.from(
  new Set(Object.values(fieldConfigByRole).flat())
);
const initialForm = ALL_VISIBLE_FIELDS.reduce<Record<string, string>>((acc, key) => {
  acc[key] = "";
  return acc;
}, {});

const AdminEntityPage: React.FC<Props> = ({ role, mode, title }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [rows, setRows] = useState<any[]>([]);
  const [form, setForm] = useState<Record<string, string>>(initialForm);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteError, setDeleteError] = useState<string | null>(null);
  const [search, setSearch] = useState("");
  const apiUrl = process.env.REACT_APP_API_URL;

  const fields = useMemo(() => fieldConfigByRole[role], [role]);
  // Required fields function signature now takes mode
  const requiredFields = useMemo(() => {
    // Accepts both legacy array and our new function signature for safety, but our own type guards it
    const req = requiredFieldsByRole[role];
    if (typeof req === "function") {
      return req(mode);
    }
    return req;
  }, [role, mode]);

  // List fetch
  useEffect(() => {
    if (!apiUrl || mode !== "list") return;
    fetch(`${apiUrl}/auth/admin/users?role=${role}`)
      .then((r) => r.json())
      .then((d) => setRows(Array.isArray(d) ? d : []))
      .catch(() => setRows([]));
  }, [apiUrl, mode, role]);

  // Reset search whenever the role/list changes so stale filters
  // from one entity list don't carry over to another
  useEffect(() => {
    setSearch("");
  }, [role, mode]);

  // Edit fetch — only populate visible fields
  useEffect(() => {
    if (!apiUrl || mode !== "edit" || !id) return;
    fetch(`${apiUrl}/auth/user/${id}`)
      .then((r) => r.json())
      .then((d) => {
        setForm((prev) => {
          const next = { ...prev };
          ALL_VISIBLE_FIELDS.forEach((key) => {
            next[key] = d?.[key] ?? "";
          });
          return next;
        });
      })
      .catch(() => setMessage("Could not load record"));
  }, [apiUrl, mode, id]);

  const validate = () => {
    const newErrors: Record<string, string> = {};
    requiredFields.forEach((field) => {
      if (!form[field]?.trim()) {
        newErrors[field] = "Required";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSave = async () => {
    if (!apiUrl) return;
    setMessage(null);
    if (!validate()) {
      setMessage("Please fill required fields.");
      return;
    }
    setLoading(true);

    try {
      const hiddenDefaults = getHiddenDefaults();

      // Build payload: hidden defaults first, then visible form values on top.
      // For any field that is hidden for this role (e.g. email on consignor),
      // the form value will be "" — we explicitly restore the default after.
      const payload: Record<string, string> = {
        ...hiddenDefaults,
        ...form,
        role,
      };

      // Restore hidden defaults for fields not visible in this role
      Object.keys(hiddenDefaults).forEach((key) => {
        if (!fields.includes(key) || !payload[key]?.trim()) {
          payload[key] = hiddenDefaults[key];
        }
      });

      const endpoint =
        mode === "edit" && id
          ? `${apiUrl}/auth/admin/users/${id}`
          : `${apiUrl}/auth/admin/users`;

      const res = await fetch(endpoint, {
        method: mode === "edit" ? "PUT" : "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || "Save failed");

      setMessage(mode === "edit" ? "Updated successfully" : "Created successfully");
      if (mode === "add") setForm(initialForm);
      if (mode === "edit") navigate(`/admin/${role}s/list`);
    } catch (e: any) {
      setMessage(e?.message || "Save failed");
    } finally {
      setLoading(false);
    }
  };

  // New: Delete (for list page, with row id as param)
  const onDelete = async (rowId: string) => {
    if (!apiUrl || !rowId) return;
    setDeleteLoading(true);
    setDeleteError(null);
    try {
      const resp = await fetch(`${apiUrl}/auth/admin/users/${rowId}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" }
      });
      let data: any = {};
      try {
        data = await resp.json();
      } catch {}
      if (!resp.ok) throw new Error(data?.error || "Delete failed");
      setDeleteLoading(false);
      setDeleteError(null);
      setRows(rows => rows.filter(r => r.id !== rowId));
      setDeleteId(null);
    } catch (e: any) {
      setDeleteLoading(false);
      setDeleteError(e?.message || "Delete failed");
    }
  };

  // Search-filtered rows — matches against every visible field for this
  // role (name, number, email, address, gst_number, etc.), case-insensitive
  const filteredRows = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter((row) => {
      const haystack = fields
        .map((f) => row?.[f])
        .filter(Boolean)
        .map((v) => String(v).toLowerCase())
        .join(" ");
      return haystack.includes(q);
    });
  }, [rows, fields, search]);

  // ── LIST VIEW ──────────────────────────────────────────────
  if (mode === "list") {
    return (
      <div className="p-4 md:p-6 ">
        <Panel
          title={`${title} - List`}
          subtitle={`Show all ${role} records with edit option`}
        >
          <div className="mb-3 flex flex-wrap items-center gap-3">
            <Link
              to={`/admin/${role}s/add`}
              className="px-3 py-2 rounded-lg text-sm bg-slate-900 text-white"
            >
              Add {title}
            </Link>
            <div className="flex-1" />
            <div className="relative">
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder={`Search ${title.toLowerCase()}…`}
                className="px-3 py-2 pr-8 text-sm rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 w-56"
              />
              {search && (
                <button
                  type="button"
                  onClick={() => setSearch("")}
                  className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 text-xs"
                  aria-label="Clear search"
                  title="Clear search"
                >
                  ✕
                </button>
              )}
            </div>
          </div>

          <div className="space-y-2">
            {filteredRows.length === 0 && (
              <p className="text-xs text-slate-500 px-1">
                {search ? `No ${role} records match your search` : `No ${role} records`}
              </p>
            )}
            {filteredRows.map((row) => (
              <div
                key={row.id}
                className="rounded-xl border border-slate-100 p-3 flex items-center justify-between"
              >
                <div>
                  <p className="text-sm font-semibold text-slate-900">{row.name}</p>
                  <p className="text-xs text-slate-500">
                {row.number}
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <Link
                    to={`/admin/${role}s/edit/${row.id}`}
                    className="px-2 py-1 text-xs rounded-md bg-slate-100 text-slate-700"
                  >
                    Edit
                  </Link>
                  <button
                    className="px-2 py-1 text-xs rounded-md bg-red-100 text-red-700"
                    disabled={deleteLoading && deleteId === row.id}
                    onClick={() => setDeleteId(row.id)}
                    type="button"
                  >
                    {deleteLoading && deleteId === row.id ? "Deleting..." : "Delete"}
                  </button>
                  {/* Centered big modal for delete confirmation */}
                  {deleteId === row.id && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
                      <div className="bg-white rounded-xl shadow-2xl border border-red-200 px-8 py-6 flex flex-col items-center">
                        <span className="text-lg font-semibold text-red-700 mb-4">Are you sure you want to delete?</span>
                        <div className="flex gap-3">
                          <button
                            onClick={() => onDelete(row.id)}
                            className="px-5 py-2 rounded text-md bg-red-600 text-white font-semibold"
                            disabled={deleteLoading}
                            type="button"
                          >
                            {deleteLoading ? "Deleting..." : "Yes, Delete"}
                          </button>
                          <button
                            onClick={() => setDeleteId(null)}
                            className="px-5 py-2 rounded text-md bg-slate-100 text-slate-700 font-semibold"
                            disabled={deleteLoading}
                            type="button"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
             
                </div>
              </div>
            ))}
          </div>
          {deleteError && (
            <div className="mt-3 text-xs text-red-600">{deleteError}</div>
          )}
        </Panel>
      </div>
    );
  }

  // ── ADD / EDIT VIEW ────────────────────────────────────────
  return (
    <div className="p-4 md:p-6">
      <Panel
        title={`${mode === "edit" ? "Edit" : "Add"} ${title}`}
        subtitle={`Manage ${role} details`}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {fields.map((field) => (
            <div key={field} className="flex flex-col">
              <input
                className={`border rounded-lg px-3 py-2 text-sm ${
                  errors[field] ? "border-red-500" : ""
                }`}
                placeholder={
                  labels[field]
                    ? `${labels[field]}${requiredFields.includes(field) ? " *" : ""}`
                    : field
                }
                value={form[field] ?? ""}
                onChange={(e) =>
                  setForm((prev) => ({ ...prev, [field]: e.target.value }))
                }
                required={requiredFields.includes(field)}
                autoComplete="off"
              />
              {errors[field] && (
                <span className="text-xs text-red-600 mt-1">{errors[field]}</span>
              )}
            </div>
          ))}
        </div>

        {message && <p className="text-xs text-slate-600 mt-3">{message}</p>}

        <div className="mt-4 flex justify-end gap-2">
          <Link
            to={`/admin/${role}s/list`}
            className="px-3 py-2 rounded-lg text-sm bg-slate-100 text-slate-700"
          >
            Back
          </Link>
          <button
            onClick={onSave}
            disabled={loading}
            className="px-3 py-2 rounded-lg text-sm bg-indigo-600 text-white disabled:opacity-60"
          >
            {loading ? "Saving..." : mode === "edit" ? "Update" : "Create"}
          </button>
        </div>
      </Panel>
    </div>
  );
};

export default AdminEntityPage;